export default __webpack_public_path__ + "static/media/matic.3399d84d.svg";